<template>
	<v-dialog persistent width="410" :value="isPopup">
		<div class="trucksRoadSendInvoices">
			<div class="trucksRoadSendInvoicesHead">Send report</div>
			<div class="groupField">
				<field
						margin="0"
						width="330px"
						type="text"
						label="Report date"
						placeholder="Enter report date"
						:dateValue="date"
						@updateDate="onDate($event)"
						:events-list="datesColor"
						:dateAllowed="{ isSameOrBefore: true }"
						is-no-title
						is-date
				></field>
			</div>
			<div class="groupField">
				<div class="groupFieldTitle">
					<span>Emails</span>
					<button
							type="button"
							@click="onAddItem"
							class="mainBtn mainBtn-text"
					>
						<span class="btnIco"><svg-sprite icon-id="addItem" width="20" height="20"></svg-sprite></span>
					</button>
				</div>
				<div class="groupField_scroll">
					<template v-for="(item, idx) in emails">
						<div class="groupField_wrap" :key="idx">
							<field
									:class-error="getError(idx)"
									margin="0"
									width="300px"
									label="Email"
									placeholder="Select email"
									:set-input-value="item.email"
									@updateInput="onInput($event)"
									:idx="idx"
									is-required
							></field>
							<button :disabled="!idx && emails.length <= 1" type="button" class="deleteItem"
							        @click="onDeleteItem(idx)">
								<svg-sprite
										:style="`color: ${!!idx || emails.length > 1 ? '#19BC38': '#8F90A6'}`"
										width="20"
										height="20"
										icon-id="deleteItem"
								></svg-sprite>
							</button>
						</div>
					</template>
				</div>
			</div>
			<div class="groupField">
				<div class="groupFieldTitle">
					<span>Report</span>
				</div>
				<div class="groupField_noScroll">
					<div class="generate_button">
						<button
								type="button"
								class="mainBtn mainBtn-text iconHoverRotate"
								@click="onGenerate"
						>
							<span class="btnIco"><svg-sprite icon-id="generate" width="20" height="20"></svg-sprite></span>
							<span class="btnText">Generate report</span>
							<v-progress-circular
									class="progressIcon"
									v-if="isGeneratePreloader"
									size="20"
									indeterminate
									color="green"
							></v-progress-circular>
						</button>
						<button
								type="button"
								class="mainBtn mainBtn-text"
								:disabled="!isGenerate"
								@click="overlay = !overlay"
						>
							<span class="btnIco"><svg-sprite icon-id="eye" width="20" height="20"></svg-sprite></span>
						</button>
					</div>
				</div>
			</div>
			<button-groups
					:preloader="isPreloader"
					applyText="send"
					@updateBtnClose="onClose"
					@updateSave="onSave"
					center
			></button-groups>
		</div>

		<preview-generated-invoice
				v-if="isGenerate"
				:overlay="overlay"
				:info="generateTrucksInvoices"
				@updateOverlay="onClosePreviewGeneratedInvoice"
		></preview-generated-invoice>
	</v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// components
import ButtonGroups from "@/shared/ButtonGroups/ButtonGroups";
// validate
import { validationMixin } from "vuelidate";
import { email, required } from "vuelidate/lib/validators";
import PreviewGeneratedInvoice from "@/components/Fleet/TrucksRoad/PreviewGeneratedInvoice/PreviewGeneratedInvoice";

export default {
	name: "TrucksRoadSendInvoices",
	mixins: [ validationMixin ],
	components: {
		ButtonGroups,
		PreviewGeneratedInvoice
	},
	props: {
		defaultEmails: Array,
		valid: Object,
		datesColor: Object,
		filters: Object,
		dateFilter: String
	},
	computed: {
		...mapGetters([ 'generateTrucksInvoices' ]),
	},
	data: () => ({
		isGeneratePreloader: false,
		isGenerate: false,
		isPopup: true,
		emails: [ { email: '' } ],
		date: null,
		isPreloader: false,
		dispatcherApproved: false,
		fleetApproved: false,
		overlay: false,
	}),
	validations: {
		emails: {
			$each: {
				email: { required, email },
			}
		},
	},
	methods: {
		...mapActions([ 'onSendTrucksInvoices', 'onGenerateTrucksInvoices', 'onTrucksRoadApproved', 'onTrucksRoadSend', 'setAlert' ]),
		onClosePreviewGeneratedInvoice() {
			this.overlay = !this.overlay;
		},
		onClose() {
			this.$emit('updateTrucksRoadClose');
		},
		async onGenerate() {
			this.$v.$touch();
			if (!this.$v.$error) {
				const {
					date,
				} = this.$data;

				const values = {
					date,
					...this.filters
				};

				this.isGeneratePreloader = true;
				await this.onInitData('onTrucksRoadApproved', { date });
				if (this.dispatcherApproved && this.fleetApproved) {
					await this.onGenerateTrucksInvoices(values);
					this.isGenerate = true;
				} else {
					let errorMassage = '';
					if (!this.fleetApproved && !this.dispatcherApproved) {
						errorMassage = 'Fleet and Dispatch';
					} else if (!this.fleetApproved) {
						errorMassage = 'Fleet';
					} else if (!this.dispatcherApproved) {
						errorMassage = 'Dispatch';
					}

					const message = `Error. Email can’t be sent because the department ${ errorMassage } did not approve the final state of data`;
					await this.setAlert({ type: "error", message });
					this.isGeneratePreloader = false;
					this.isGenerate = false;
				}
				this.isGeneratePreloader = false;
			}
		},
		async onSave() {
			this.$v.$touch();
			if (!this.$v.$error) {
				const {
					date,
					emails
				} = this.$data;

				const values = {
					date,
					emails,
					...this.filters
				};

				this.isPreloader = true;
				await this.onInitData('onTrucksRoadApproved', { date });
				if (this.dispatcherApproved && this.fleetApproved) {
					await this.onSendTrucksInvoices(values);
					this.onClose();
				} else {
					let errorMassage = '';
					if (!this.fleetApproved && !this.dispatcherApproved) {
						errorMassage = 'Fleet and Dispatch';
					} else if (!this.fleetApproved) {
						errorMassage = 'Fleet';
					} else if (!this.dispatcherApproved) {
						errorMassage = 'Dispatch';
					}

					const message = `Error. Email can’t be sent because the department ${ errorMassage } did not approve the final state of data`;
					await this.setAlert({ type: "error", message });
					this.isPreloader = false;
				}
			}
		},
		onInput({ value, idx }) {
			this.emails[idx]['email'] = value;
		},
		onDate(value) {
			this.date = value;
			this.isGenerate = false;
		},
		getError(idx) {
			return this.$v.emails?.$each?.$iter[idx]?.email?.$error;
		},
		onAddItem() {
			this.emails.push({ email: null });
		},
		onDeleteItem(idx) {
			this.emails.splice(idx, 1);
		},
		async onInitData(request, value) {
			const { data } = await this[request](value);
			const { dispatcher_approved, fleet_approved } = data || {};
			this.dispatcherApproved = dispatcher_approved;
			this.fleetApproved = fleet_approved;
		}
	},
	async mounted() {
		this.emails = this.defaultEmails;
		this.date = this.dateFilter;
		await this.onInitData('onTrucksRoadSend', null);
	}
};
</script>

<style scoped lang="scss">
@import "truckRoadSendInvoices";
</style>
